module.exports = __webpack_public_path__ + "static/media/the_microf_story.73d58026.mp4";